import { List } from 'antd';
import React, { FC } from 'react';
import { ProjectId, ProjectMember } from 'api/models';
import { useMemberships } from 'hooks/use-memberships';
import { useUserProjectPermissions } from 'hooks/use-user-project-permissions';
import { Memberships } from 'stores/memberships';
import { useActiveProjectConversation } from '../../../proj-conversation-hooks';
import { MembersEmptyList } from './members-empty';
import { ListItem } from './members-list-item';

export const MembersList: FC<{
  projectId: number;
}> = ({ projectId }) => {
  const [status, memberships = Memberships.empty()] = useMemberships(
    ProjectId(projectId),
  );
  const loggedInUserPermissions = useUserProjectPermissions(projectId);
  const activeConversation = useActiveProjectConversation();

  return activeConversation?.members &&
    activeConversation.members?.length > 0 ? (
    <List
      itemLayout="horizontal"
      dataSource={activeConversation.members}
      loading={status === 'loading'}
      renderItem={(memberDetails: { user: ProjectMember }) => (
        <ListItem
          memberships={memberships}
          member={memberDetails.user}
          projectId={projectId}
          loggedInUserPermissions={loggedInUserPermissions}
        />
      )}
    />
  ) : (
    <MembersEmptyList />
  );
};
